import { useState } from "react";
import CustomVideoPlayer from "../core/CustomVideoPlayer";

import vid from "assets/videos/vi1.mp4";
import { deletedPNG } from "utils/assets_exports/images";
const PostMedia5 = () => {
    const [deleted, setDeleted] = useState(false);
    return (
        <div className="post-image relative">
            <CustomVideoPlayer src={vid} />
            {deleted && (
                <img
                    src={deletedPNG}
                    alt="deleted icon"
                    className="vid-delete-png"
                />
            )}
            <div className="text-center pt-3">
                <button
                    className={`${deleted ? "bg-momeento-50" : "bg-red-600"} text-white text-center rounded-full w-fit px-3 py-1`}
                    onClick={() => setDeleted(!deleted)}
                >
                    {deleted ? "Restore Video" : "Delete Video"}
                </button>
            </div>
        </div>
    );
};

export default PostMedia5;
